import React, { type ComponentProps, type PropsWithChildren, useCallback } from 'react';

import { AnalyticsListener } from '@atlaskit/analytics-next';
import { ANALYTICS_BRIDGE_CHANNEL } from '@atlassian/analytics-bridge';

export type AnalyticsProviderProps = {
	product: string;
	client: any;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export const AnalyticsProvider: React.FC<PropsWithChildren<AnalyticsProviderProps>> = ({
	children,
	product,
	client,
}) => {
	const onEvent = useCallback<ComponentProps<typeof AnalyticsListener>['onEvent']>(
		({ payload }) => {
			client?.onEvent?.(ANALYTICS_BRIDGE_CHANNEL, {
				...payload,
				attributes: {
					...payload?.attributes,
					product,
				},
			});
		},
		[client, product],
	);

	return (
		<AnalyticsListener channel={ANALYTICS_BRIDGE_CHANNEL} onEvent={onEvent}>
			{children}
		</AnalyticsListener>
	);
};
